import { useMemo } from "react";

import { ChallengesReducer } from "reducers/challenges";
import { useAppSelector } from "store";

import type { ChallengeIdeaQueryParams } from "../../types";

export const useIdeaQueryParams = (
  ideaViewType: ChallengesReducer["ideaViewType"],
): ChallengeIdeaQueryParams => {
  const challengesReducer: ChallengesReducer = useAppSelector(
    (state) => state.challenges,
  );
  const {
    tagFilter,
    ideaFilter: query,
    ideaIncludes: filter,
    ideaOrder: sort,
    ideaOrderDirection: sortDirection,
    ideaPage: page,
    labelsFilter: labels,
    ideaLimit: limit,
    ideaFieldChoices: fieldChoices,
    projectBoardLanesFilter,
    groupFilter,
    orgFilter,
    projectBoardFilter,
    adminHasCommented,
    customDeadline,
    impactFilter,
  } = challengesReducer;

  return useMemo(
    () => ({
      ideaViewType,
      page: ideaViewType === "board" ? 1 : page,
      query,
      tags: tagFilter,
      filter: filter || "all",
      sort,
      sortDirection,
      labels,
      groupFilter,
      orgFilter,
      fieldChoices,
      limit: ideaViewType === "board" ? 10000 : limit,
      adminHasCommented,
      customDeadline,
      projectBoardFilter,
      projectBoardLanesFilter,
      impactFilter,
    }),
    [
      ideaViewType,
      page,
      query,
      tagFilter,
      filter,
      sort,
      sortDirection,
      labels,
      groupFilter,
      orgFilter,
      fieldChoices,
      limit,
      adminHasCommented,
      customDeadline,
      projectBoardFilter,
      projectBoardLanesFilter,
      impactFilter,
    ],
  );
};
